import React from "react";
import { Row, Col } from "react-bootstrap";
function Home() {
  return (
    <Row>
      <Col sm>
        <div className="info-container">
          <div>
            <h3 className="app-title">TodToli</h3>
            <p className="slogan">Ертөнцийг тодоор тольд</p>
            <p className="about-app">
              TodToli нь боловсролын хүртээмжтэй байдлыг хангах зорилготой
              гадаад хэл сурдаг апп юм.
            </p>
            <div className="downloads-container">
              <a
                className="download"
                href="https://apps.apple.com/us/app/todtoli/id1607940412"
              >
                <img src="/appstore.png" alt="appstore" />
              </a>
              <a
                className="download"
                href="https://play.google.com/store/apps/details?id=mn.yesitis.letslearnenglish"
              >
                <img src="/playstore.png" alt="playstore" />
              </a>
            </div>
            <br />
            <br />
          </div>
        </div>
      </Col>
      <Col className="appscreen" sm>
        <img src="/appscreen.png" alt="appscreen" />
      </Col>
    </Row>
  );
}
export default Home;
